import Vue from "vue";
import Router from "vue-router";
import { get } from './Utils/axios.js';

Vue.use(Router);

const router = new Router({
  // mode:'history',
  routes: [
    // {
    //   path: "/sat", // 菜单跳转
    //   name: "sat",
    //   component: (resolve) => require(["@/components/Home/Home"], resolve),
    //   children: [
    //     {
    //       path: '/sat/estimated-record',
    //       functionName: '预估记录',
    //       name: 'estimated-record',
    //       component: (resolve) => require(["@/components/EstimatedRecord/EstimatedRecord"], resolve),
    //     },
    //     {
    //       path: '/sat/estimated-record/details',
    //       functionName: '预估记录详情',
    //       name: 'estimated-details',
    //       component: (resolve) => require(["@/components/EstimatedRecord/EstimatedDetails"], resolve),
    //     },
    //     {
    //       path: '/sat/estimated-record/add',
    //       functionName: '新建预估',
    //       name: 'estimated-add',
    //       component: (resolve) => require(["@/components/EstimatedRecord/EstimatedCopy"], resolve),
    //     },
    //     {
    //       path: '/sat/estimated-record/copy',
    //       functionName: '复制预估',
    //       name: 'estimated-copy',
    //       component: (resolve) => require(["@/components/EstimatedRecord/EstimatedCopy"], resolve),
    //     },
    //   ],
    // },
    {
      path: '/sat/estimated-record/details',
      functionName: '预估记录详情',
      name: 'estimated-details',
      component: (resolve) => require(["@/components/EstimatedRecord/EstimatedDetails.vue"], resolve),
    },

    {
      path: '/sat/estimated-record/add',
      functionName: '新建预估',
      name: 'estimated-add',
      component: (resolve) => require(["@/components/EstimatedRecord/EstimatedCopy.vue"], resolve),
    },
    {
      path: '/sat/estimated-record',
      functionName: '预估记录',
      name: 'estimated-record',
      component: (resolve) => require(["@/components/EstimatedRecord/EstimatedRecord.vue"], resolve),
    },

    {
      path: "/mainPage", // 菜单跳转
      name: "mainPage",
      component: (resolve) => require(["@/components/Home/Home.vue"], resolve),
      children: [
        {
          functionName: "原料管理",
          path: "/mainPage/materialManagement",
          name: "materialManagement",
          component: (resolve) =>
            require([
              "@/components/Material/MaterialManagement/MaterialManagement.vue",
            ], resolve),
        },
        {
          functionName: "原料养分",
          path: "/mainPage/materialManagement/nutrient-list",
          name: "NutrientList",
          component: (resolve) =>
            require([
              "@/components/Material/MaterialManagement/NutrientList.vue",
            ], resolve),
        },
        // /mainPage/customer-management
        // CustomerMaterial
        {
          functionName: "客户管理",
          path: "/mainPage/customer-management",
          name: "customer-management",
          component: (resolve) => require(["@/components/Material/CustomerManagement/CustomerManagement.vue",], resolve),
        },
        {
          functionName: "客户管理-原料维护",
          path: "/mainPage/customer-material",
          name: "customer-material",
          component: (resolve) => require(["@/components/Material/CustomerManagement/CustomerMaterial.vue",], resolve),
        },
        {
          functionName: "客户管理-营养指标维护",
          path: "/mainPage/customer-nutrient",
          name: "customer-nutrient",
          component: (resolve) => require(["@/components/Material/CustomerManagement/CustomerNutrient.vue",], resolve),
        },
        {
          functionName: "营养指标管理",
          path: "/mainPage/nutritional-indicator",
          name: "NutritionalIndicator",
          component: (resolve) =>
            require([
              "@/components/Material/NutritionalIndicator/NutritionalIndicator.vue",
            ], resolve),
        },
        {
          functionName: "指标查看",
          path: "/mainPage/nutritional-indicator/index-view",
          name: "index-view",
          component: (resolve) =>
            require([
              "@/components/Material/NutritionalIndicator/IndexView.vue",
            ], resolve),
        },
        {
          path: "/system/my-message",
          name: "my-message",
          component: (resolve) =>
            require(["@/components/System/MyMessage/MyMessage.vue"], resolve),
        },
        {
          path: "/system/operation-log",
          name: "operation-log",
          component: (resolve) =>
            require(["@/components/System/OperationLog/OperationLog.vue"], resolve),
        },
        {
          path: "/system/nhf-export-management",  // 导出管理
          name: "nhf-export-management",
          component: (resolve) =>
            require(["@/components/System/ExportManage/ExportManage.vue"], resolve),
        },
        {
          path: "/recipe/recipe-feed",
          name: "recipe-feed",
          component: (resolve) =>
            require(["@/components/Recipe/RecipeFeed/RecipeFeed.vue"], resolve),
        },
        {
          path: "/system/editing-record", // 原料编辑记录
          name: "editing-record",
          component: (resolve) =>
            require([
              "@/components/System/MaterialEditingRecord/MaterialEditingRecord.vue",
            ], resolve),
        },
        {
          path: "/system/material-maintenance-record", // 原料数据库维护记录
          name: "material-maintenance-record",
          component: (resolve) =>
            require([
              "@/components/System/MaterialMaintenanceRecord/MaterialMaintenanceRecord.vue",
            ], resolve),
        },
        {
          path: "/nhf/compound-feed",
          name: "compound-feed",
          component: (resolve) =>
            require(["@/components/Nhf/Compound/CompoundFeed.vue"], resolve),
        },
        {
          functionName: "配合饲料-查看",
          path: "/nhf/compound-feed/CompoundDetail",
          name: "compound-detail",
          component: (resolve) =>
            require(["@/components/Nhf/Compound/CompoundDetail.vue"], resolve),
        },
        {
          functionName: "混合日粮",
          path: "/nhf/blend",
          name: "blend",
          component: (resolve) =>
            require(["@/components/Nhf/Blend/Blend.vue"], resolve),
        },
        {
          functionName: '定制料',
          path: '/nhf/customized-list',
          name: 'customized',
          component: (resolve) => require(["@/components/Nhf/Customized/Customized.vue"], resolve),
        },
        {
          functionName: 'Multiple配方',
          path: '/nhf/pushed-formula',
          name: 'pushed',
          component: (resolve) => require(["@/components/Nhf/Pushed/Pushed.vue"], resolve),
        },
        {
          functionName: '代工配方',
          path: '/nhf/OEM-formula',
          name: 'OEM',
          component: (resolve) => require(["@/components/Nhf/OEM/OEM.vue"], resolve),
        },
        {
          functionName: "预计生产量表",
          path: "/production/estimate",
          name: "estimate",
          component: (resolve) =>
            require([
              "@/components/ProductionManagement/Estimate/Estimate.vue",
            ], resolve),
        },
        {
          functionName: "EBS配方执行数据",
          path: "/production/EBS-formula",
          name: "EBS-formula",
          component: (resolve) =>
            require([
              "@/components/ProductionManagement/EBSFormula/EBSFormula.vue",
            ], resolve),
        },
        {
          functionName: "分享管理",
          path: "/shareManagement/shareManagementList",
          name: "shareManagementList",
          component: (resolve) =>
            require(["@/components/ShareManagement/Index.vue"], resolve),
        },
        {
          functionName: "产品详情",
          path: "/shareManagement/shareManagementList/share-product-detail",
          name: "share-product-detail",
          component: (resolve) =>
            require(["@/components/ShareManagement/ProductionDetail.vue"], resolve),
        },
        {
          functionName: "产品记录",
          path: "/nhf-product/list",
          name: "list",
          component: (resolve) =>
            require(["@/components/Product/ProductManagement.vue"], resolve),
        },
        {
          functionName: "产品详情",
          path: "/nhf-product/list/product-detail",
          name: "product-detail",
          component: (resolve) =>
            require(["@/components/Product/ProductionDetail.vue"], resolve),
        },
        {
          functionName: "产品对比",
          path: "/nhf-product/list/product-comparison",
          name: "product-comparison",
          component: (resolve) =>
            require(["@/components/Product/ProductComparison.vue"], resolve),
        },
        {
          functionName: "定制料产品记录",
          path: "/nhf-product/customized-product-list",
          name: "customized-product-list",
          component: (resolve) =>
            require(["@/components/ProductCustomized/ProductManagement.vue"], resolve),
        },
        {
          functionName: "定制料产品详情",
          path: "/nhf-product/list/customized-product-detail",
          name: "customized-product-detail",
          component: (resolve) =>
            require(["@/components/ProductCustomized/ProductionDetail.vue"], resolve),
        },
        {
          functionName: "多配方任务",
          path: "/formula/formula-task",
          name: "formula-task",
          component: (resolve) => require(["@/components/Formula/TaskList.vue"], resolve),
        },
        {
          functionName: "五日测算",
          path: "/formula/fivedaycalc",
          name: "formula-fivedaycalc",
          component: (resolve) => require(["@/components/FormulaFiveDaysCalc/Index.vue"], resolve),
        },
        {
          functionName: "测算配方管理",
          path: "/fivedayscalc/formula-manage",
          name: "formula-manage",
          component: (resolve) => require(["@/components/FiveDaysCalc/FormulaManage.vue"], resolve),
        },
        {
          functionName: "测算期间管理",
          path: "/fivedayscalc/calc-range-manage",
          name: "calc-range-manage",
          component: (resolve) => require(["@/components/FiveDaysCalc/CalcRangeManage.vue"], resolve),
        },
        // fast迁移
        {
          functionName: '配方原料分析',
          path: '/fast/MaterialAnalyse',
          name: 'MaterialAnalyse',
          component: resolve => require(['@/components/FAST/MaterialAnalyse/Index.vue'], resolve)
        },
        {
          functionName: '配方营养分析',
          path: '/fast/NutritionAnalyse',
          name: 'NutritionAnalyse',
          component: resolve => require(['@/components/FAST/NutritionAnalyse/Index.vue'], resolve)
        },
        {
          functionName: '产品原料分析',
          path: '/fast/ProductRawAnalyse',
          name: 'ProductRawAnalyse',
          component: resolve => require(['@/components/FAST/ProductRawAnalyse/Index'], resolve)
        },
        {
          functionName: '产品营养分析',
          path: '/fast/ProductNutritionAnalyse',
          name: 'ProductNutritionAnalyse',
          component: resolve => require(['@/components/FAST/ProductNutritionAnalyse/Index'], resolve)
        },
        {
          functionName: '配方原料历史分析',
          path: '/fast/MaterialHistoryAnalyse',
          name: 'MaterialHistoryAnalyse',
          component: resolve => require(['@/components/FAST/MaterialHistoryAnalyse/Index.vue'], resolve)
        },
        {
          functionName: '配方营养历史分析',
          path: '/fast/NutritionHistoryAnalyse',
          name: 'NutritionHistoryAnalyse',
          component: resolve => require(['@/components/FAST/NutritionHistoryAnalyse/Index.vue'], resolve)
        },
        {
          functionName: '配方管理归档',
          path: '/archive-data/formula',
          name: 'archive-data-formula',
          component: resolve => require(['@/components/ArchiveDataManagement/FormulaAdministration/FormulaAdministration'], resolve)
        },
        {
          functionName: "配合饲料归档详情",
          path: "/archive-data/formula/archive-data-compound-detail",
          name: "archive-data-compound-detail",
          component: (resolve) =>
              require(["@/components/ArchiveDataManagement/FormulaAdministration/CompoundDetail"], resolve),
        },
        {
          functionName: '定制料管理归档',
          path: '/archive-data/customized-formula',
          name: 'archive-data-customized-formula',
          component: resolve => require(['@/components/ArchiveDataManagement/CustomizedFormula/FormulaAdministration'], resolve)
        },
        {
          functionName: "定制料饲料归档详情",
          path: "/archive-data/customized-formula/archive-data-customized-compound-detail",
          name: "archive-data-customized-compound-detail",
          component: (resolve) =>
              require(["@/components/ArchiveDataManagement/CustomizedFormula/CompoundDetail"], resolve),
        },
        {
          functionName: '混合日粮归档',
          path: '/archive-data/archive-data-blend',
          name: 'archive-data-blend',
          component: resolve => require(['@/components/ArchiveDataManagement/Blend/Blend'], resolve)
        },
        {
          functionName: '混合日粮归档详情',
          path: '/archive-data/archive-data-blend/archive-data-blend-detail',
          name: 'archive-data-blend-detail',
          component: resolve => require(['@/components/ArchiveDataManagement/Blend/BlendDetail'], resolve)
        },
        {
          functionName: "产品记录归档",
          path: "/archive-data/archive-data-product-list",
          name: "archive-data-product-list",
          component: (resolve) =>
              require(["@/components/ArchiveDataManagement/ArchiveProduct/ProductManagement.vue"], resolve),
        },
        {
          functionName: "产品归档详情",
          path: "/archive-data/archive-data-product-list/archive-data-product-detail",
          name: "archive-data-product-detail",
          component: (resolve) =>
              require(["@/components/ArchiveDataManagement/ArchiveProduct/ProductionDetail.vue"], resolve),
        },
        {
          functionName: "定制料产品记录归档",
          path: "/archive-data/archive-data-customized-product-list",
          name: "archive-data-customized-product-list",
          component: (resolve) =>
              require(["@/components/ArchiveDataManagement/ArchiveProductCustomized/ProductManagement.vue"], resolve),
        },
        {
          functionName: "定制料归档详情",
          path: "/archive-data/archive-data-customized-product-list/archive-data-customized-product-detail",
          name: "archive-data-customized-product-detail",
          component: (resolve) =>
              require(["@/components/ArchiveDataManagement/ArchiveProductCustomized/ProductionDetail.vue"], resolve),
        },
        {
          functionName: '猪线路',
          path: '/empirical-data/pig',
          name: 'pig-list',
          component: resolve => require(['@/components/EmpiricalData/Pig.vue'], resolve)
        },
        {
          functionName: '喜报',
          path: '/empirical-data/pig/good-news',
          name: 'GoodNews-pig',
          component: resolve => require(['@/components/EmpiricalData/GoodNews.vue'], resolve)
        },
        {
          functionName: '猪线路详情',
          path: '/empirical-data/pig/pig-detail',
          name: 'pig-detail',
          component: resolve => require(['@/components/EmpiricalData/PigDetail.vue'], resolve)
        },
        {
          functionName: '猪线路新建',
          path: '/empirical-data/pig/pig-new-data',
          name: 'add-pig',
          component: resolve => require(['@/components/EmpiricalData/PigNewData.vue'], resolve)
        },
        {
          functionName: '猪线路复制',
          path: '/empirical-data/pig/pig-copy-data',
          name: 'copy-pig',
          component: resolve => require(['@/components/EmpiricalData/PigNewData.vue'], resolve)
        },
        {
          functionName: '反刍线路',
          path: '/empirical-data/ruminate',
          name: 'ruminate-list',
          component: resolve => require(['@/components/EmpiricalData/Ruminate.vue'], resolve)
        },
        {
          functionName: '反刍线路详情',
          path: '/empirical-data/ruminate/ruminate-detail',
          name: 'ruminate-detail',
          component: resolve => require(['@/components/EmpiricalData/RuminateDetail.vue'], resolve)
        },
        {
          functionName: '反刍线路新建',
          path: '/empirical-data/ruminate/ruminate-new-data',
          name: 'add-ruminate',
          component: resolve => require(['@/components/EmpiricalData/RuminateNewData.vue'], resolve)
        },
        {
          functionName: '反刍线路复制',
          path: '/empirical-data/ruminate/ruminate-copy-data',
          name: 'copy-ruminate',
          component: resolve => require(['@/components/EmpiricalData/RuminateNewData.vue'], resolve)
        },
        {
          functionName: '禽线路',
          path: '/empirical-data/poultry',
          name: 'poultry-list',
          component: resolve => require(['@/components/EmpiricalData/Poultry.vue'], resolve)
        },
        {
          functionName: '肉禽线路详情',
          path: '/empirical-data/poultry/meat-detail',
          name: 'poultry-meat-detail',
          component: resolve => require(['@/components/EmpiricalData/MeatDetail.vue'], resolve)
        },
        {
          functionName: '肉禽线路新建',
          path: '/empirical-data/poultry/meat-new-data',
          name: 'add-poultry',
          component: resolve => require(['@/components/EmpiricalData/MeatNewData.vue'], resolve)
        },
        {
          functionName: '肉禽线路复制',
          path: '/empirical-data/poultry/meat-copy-data',
          name: 'copy-meat-poultry',
          component: resolve => require(['@/components/EmpiricalData/MeatNewData.vue'], resolve)
        },
        {
          functionName: '蛋禽线路详情',
          path: '/empirical-data/poultry/egg-detail',
          name: 'egg-detail',
          component: resolve => require(['@/components/EmpiricalData/EggDetail.vue'], resolve)
        },
        {
          functionName: '蛋禽线路新建',
          path: '/empirical-data/poultry/egg-new-data',
          name: 'add-egg-poultry',
          component: resolve => require(['@/components/EmpiricalData/EggNewData.vue'], resolve)
        },
        {
          functionName: '蛋禽线路复制',
          path: '/empirical-data/poultry/egg-copy-data',
          name: 'copy-egg-poultry',
          component: resolve => require(['@/components/EmpiricalData/EggNewData.vue'], resolve)
        },
        {
          functionName: '水产线路',
          path: '/empirical-data/aquatic',
          name: 'aquatic-list',
          component: resolve => require(['@/components/EmpiricalData/Fish.vue'], resolve)
        },
        {
          functionName: '水产线路详情',
          path: '/empirical-data/aquatic/fish-detail',
          name: 'aquatic-detail',
          component: resolve => require(['@/components/EmpiricalData/FishDetail.vue'], resolve)
        },
        {
          functionName: '水产线路新建',
          path: '/empirical-data/aquatic/fish-new-data',
          name: 'add-aquatic',
          component: resolve => require(['@/components/EmpiricalData/FishNewData.vue'], resolve)
        },
        {
          functionName: '水产线路复制',
          path: '/empirical-data/aquatic/fish-copy-data',
          name: 'copy-aquatic',
          component: resolve => require(['@/components/EmpiricalData/FishNewData.vue'], resolve)
        },
        {
          functionName: '研发成果查询',
          path: '/rmp/rd-result',
          name: 'rd-result',
          component: resolve => require(['@/components/RMP/RDResult.vue'], resolve)
        },
        {
          functionName: "研发成果查看",
          path: '/rmp/rd-result/rd-result-detail',
          name: "rd-result-detail",
          component: (resolve) => require(["@/components/RMP/RDResultDetail.vue"], resolve),
        },
      ],
    },

    {
      path: "/factory",
      name: "noside",
      component: (resolve) => require(["@/components/Noside/Noside.vue"], resolve),
      children: [
        {
          functionName: "工厂选择",
          path: "/factory",
          name: "GetFactory",
          component: (resolve) =>
            require(["@/components/GetFactory/GetFactory.vue"], resolve),
        },
        {
          functionName: "公告管理",
          path: "/notice",
          name: "notice",
          component: (resolve) =>
            require(["@/components/NoticeManagement/index.vue"], resolve),
        },
        {
          path: "/nhf-compound-report",
          name: "compound-report",
          component: (resolve) =>
            require(["@/components/Nhf/Compound/ReportDownload.vue"], resolve),
        },
        {
          path: "/nhf-mix-report",
          name: "mix-report",
          component: (resolve) =>
            require(["@/components/Nhf/Blend/ReportDownload.vue"], resolve),
        },
        {
          functionName: "配方管理",
          path: "/recipe/edit-recipe",
          name: "edit-recipe",
          component: (resolve) =>
            require(["@/components/Recipe/EditRecipe/EditRecipe.vue"], resolve),
        }
      ],
    },
    {
      functionName: "配方设计",
      path: "/nhf-compound-editor",
      name: "nhf-compound-editor",
      component: (resolve) => require(["@/components/Nhf/Compound/CompoundEditorCol.vue"], resolve),
    },
    {
      path: "/nhf-formula-editor",
      name: "nhf-formula-editor",
      component: (resolve) => require(["@/components/FormulaFiveDaysCalc/FormulaEditor.vue"], resolve),
    },
    {
      path: "/nhf-formula-task-speed-editor",
      name: "nhf-formula-task-speed-editor",
      component: (resolve) => require(["@/components/Formula/FormulaEditor.vue"], resolve),
    },
    {
      functionName: "混合日粮-配方设计",
      path: "/nhf-blend-editor",
      name: "blend-editor",
      // component: resolve => require(['@/components/Nhf/Compound/CompoundEditor'], resolve)
      component: (resolve) => require(["@/components/Nhf/Blend/BlendEditorCol.vue"], resolve),
    },
    {
      functionName: '定制料-详情页面',
      path: '/nhf/customized-formula',
      name: 'customized-formula',
      component: (resolve) => require(["@/components/Nhf/Customized/CustomizedDetail.vue"], resolve),
    },
    {
      functionName: '代工配方-配方设计',
      path: '/nhf/OEM-formula/formula-design',
      name: 'OEMFormulaDesign',
      component: (resolve) => require(["@/components/Nhf/OEM/OEMFormulaDesign.vue"], resolve),
    },
    // 配方模拟
    {
      functionName: "配方模拟-配方设计",
      path: "/nhf-compound-simulation",
      name: "compound-simulation",
      component: (resolve) => require(["@/components/FormulationSimulation/Compound/CompoundEditorCol.vue"], resolve),
    },
    {
      functionName: "配方模拟-混合日粮-配方设计",
      path: "/nhf-blend-simulation",
      name: "blend-simulation",
      component: (resolve) => require(["@/components/FormulationSimulation/Blend/BlendEditorCol.vue"], resolve),
    },
    {
      functionName: "飞书登录",
      path: "/login",
      name: "login",
      component: (resolve) => require(["@/components/Login/QRLogin.vue"], resolve),
    },
    {
      functionName: "账号密码登录",
      path: "/hopeye-nhf",
      name: "index",
      component: (resolve) => require(["@/components/Login/Login.vue"], resolve),
    },
    {
      functionName: "登录验证",
      path: "/checkLogin",
      name: "check-login",
      component: (resolve) =>
        require(["@/components/Login/CheckLogin.vue"], resolve),
    },
    {
      functionName: "404页面",
      path: "*",
      name: "core",
      component: (resolve) => require(["@/components/Home/Home.vue"], resolve),
      children: [
        {
          functionName: "404页面",
          path: "*",
          name: "404",
          component: (resolve) =>
            require(["@/components/NotFound/NotFound.vue"], resolve),
        },
      ],
    },
  ],
});

const noLoginPaths = ['/login', '/checkLogin', '/hopeye-nhf', '/'];

// 添加全局导航守卫
router.beforeEach((to, from, next) => {
  // 非白名单都需要校验
  if (!noLoginPaths.includes(to.path)) {
    // 获取userId
    let userId = window.localStorage.getItem("staffId");
    // 检查权限
    get('/iot-user/userState', { userId }).then(res => {
      if (res.data === 0) {
        // 继续导航
        next();
      } else {
        // 清理缓存，重新导航至登录页
        window.localStorage.removeItem("accessToken");
        window.localStorage.removeItem("userName");
        window.localStorage.removeItem("staffId");
        window.localStorage.removeItem("loginTime");
        window.localStorage.removeItem("refreshToken");
        window.localStorage.setItem("ssoLoginOut", true);
        window.localStorage.removeItem("factoryId");
        window.localStorage.removeItem("factory");
        window.localStorage.removeItem("factoryName");
        next("/login");
      }
    }, () => {
      next("/login");
    });
  } else {
    next();
  }
});

export default router;
